module.exports = __webpack_public_path__ + "img/Yellow-R-1@2x.502dc0a1.png";